import { ReportSettings, ReportSettingsConfig } from "./report_settings"

const config: ReportSettingsConfig = {
  statusEndpoint: "/organization/payment-history-report/status",
  requestEndpoint: "/organization/payment-history-report/request",
  requestButtonText: "Request Payment History Report",
  requestingText: "Sending Request...",
  notReceivingText: "No report received in the last 90 days",
  setupRequiredText: "Please configure Gmail or Microsoft integration to receive payment history reports",
  cooldownDays: 30,
}

export function PaymentHistoryReportSettings() {
  return <ReportSettings config={config} />
}
